import { CENTURION } from '../constants/cardTypeConstants';
import { getTopCard } from './membership';

export const getTravelerLocale = (membershipData) => getTopCard(membershipData)
  ?.demographics?.homeCountryLocale;

export const getCardType = (membershipData) => getTopCard(membershipData)
  ?.demographics?.product?.productFamily;

export const getCardArt = (membershipData) => getTopCard(membershipData)
  ?.demographics?.product?.cardArtCdnLink;

export const getTravelerIACode = (membershipData) => getTopCard(membershipData)
  ?.demographics?.product?.productId;

export const getSelectedAccountFromTravelerV2 = (travelerV2Data) => {
  const loyaltyAccounts = travelerV2Data?.loyalty?.accounts || [];
  const topCardIdCode = travelerV2Data?.card?.cardIdCode;
  if (topCardIdCode) {
    const topCardAccount = loyaltyAccounts.find((account) => account?.cardIdCode === topCardIdCode);
    if (topCardAccount) {
      return topCardAccount;
    }
  }
  return travelerV2Data?.loyalty?.accounts?.[0];
};

export const getTravelerPoints = (membershipData) => {
  if (!membershipData) return null;
  const selectedAccount = getTopCard(membershipData);
  return selectedAccount?.loyalty?.pointsBalance;
};

export const getIsCenturion = (membershipData) => getCardType(membershipData) === CENTURION;

export const isCenturionEligible = (
  hasCenturion,
  membershipData
) => hasCenturion && getIsCenturion(membershipData);

export const getFormattedAccountNumber = (membershipData) => {
  const LAST_DIGITS_NUMBER = 4;
  const accountNumber = getTopCard(membershipData)?.demographics?.displayAccountNumber;
  return accountNumber ? accountNumber.slice(-LAST_DIGITS_NUMBER) : null;
};

export const getTravelCredits = (membershipData) => getTopCard(membershipData)?.travelCredits || [];
